

<script>
const X = 0, Y = 1;

const lerp = (a, b, t) => b*t + (1-t)*a;
const bezier = (cs, t) => {
  if (cs.length == 1) return cs[0];
  let cs2 = new Array(cs.length - 1);
  for (let i = 0; i < cs2.length; ++i)
    cs2[i] = [
      lerp(cs[i][X], cs[i + 1][X], t),
      lerp(cs[i][Y], cs[i + 1][Y], t),
    ];
  return bezier(cs2, t);
}
(c0, c1, c2, c3, t) => [
  lerp(lerp(lerp(c0[X], c1[X], t), lerp(c1[X], c2[X], t), t), lerp(c2[X], c3[X], t), t),
  lerp(lerp(lerp(c0[Y], c1[Y], t), lerp(c1[Y], c2[Y], t), t), lerp(c2[Y], c3[Y], t), t)
];
let mouse = [ 0, 0 ];
let mouseHandler;
export default {
  props: [ 'slack', 'selectedCard' ],
  data() {
    return {
      ctx: null,
      cards: []
    };
  },
  methods: {
    renderLine() {
      if (!this.ctx) {
        console.warn("Tried to render line without a drawing context");
        return;
      }

      const { ctx } = this;
      const boundingBox = ctx.canvas.getBoundingClientRect();
      const dim = [ boundingBox.width, boundingBox.height ];
      ctx.canvas.width = boundingBox.width;
      ctx.canvas.height = boundingBox.height;

      const arcLength = dim[X] + dim[X]*this.slack;


      const maxWidth = Math.max(dim[X], arcLength);
      let x = dim[X];
      let diff = arcLength - x;
      let quart = arcLength/3;
      let qw = quart - diff/2;
      let qh = Math.sqrt(quart*quart - qw*qw);

      let c0 = [0, 0];
      let c1 = [qw, qh];
      let c2 = [qw + quart, qh];
      let c3 = [x, 0];

      ctx.clearRect(0, 0, dim[X], dim[Y]);
      ctx.lineWidth = Math.min(Math.max(2.5*window.innerWidth/1500, 0.5), 2.5);
      ctx.strokeStyle = "#442222";

      ctx.beginPath();
      ctx.moveTo(c0[X], c0[Y]);
      ctx.bezierCurveTo(
        c1[X], c1[Y],
        c2[X], c2[Y],
        c3[X], c3[Y]);
      ctx.stroke();

      const cards = this.$slots.default.filter(c => c.tag);

      cards.forEach((c, i) => {
          const el = c.elm.parentElement;

          let r = Math.atan(el.offsetWidth/el.offsetHeight);
          const t = (i + 1) / (cards.length + 1);
          const p = bezier([c0, c1, c2, c3], t);
          el.style = `transform: translate(${p[X]}px, ${p[Y]}px) rotateZ(${r}rad);`;
        });
    }
  },
  render(h) {
    return h('div',
      { class: "card-line-container" },
      [
        h('canvas', { ref: 'canvas', class: 'line-canvas' }, null),
        h('ul',
          { class: "card-line-list" },
          this.$slots.default
            .filter(c => c.tag)
            .map((c, i) => {
              let cardClass = "card-line-card-container";
              if (this.selectedCard === i) cardClass += " card-line-card--active";

              return h('li', { class: cardClass }, [c]);
            }))
      ]
    );
  },
  mounted() {

    const canvas = this.$refs.canvas;
    this.ctx = canvas.getContext('2d');
    this.renderLine();
    
    window.addEventListener('resize', this.renderLine);


  },
  beforeDestroy() {
    window.removeEventListener('resize', this.renderLine);
  }

}
</script>

<style lang="scss">

.card-line-container {
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    width: 5px; height: 20px;

    border: 1px solid rgba(0,0,0, 0.2);
    background: palegoldenrod;
    border-radius: 10% ;
  }

  &::before {
    left: 0;
    transform: translate3d(0, -50%, 0) rotate(30deg);
  }
  &::after {
    right: 0;
    transform: translate3d(0, -50%, 0) rotate(-30deg);
  }
}

.line-canvas {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.card-line-list {
  position: absolute;
  top: 0; left: 0;
}

.card-line-card-container {
  position: absolute;
  top: 0; left: 0;
  transform-style: preserve-3d;
  transform-origin: top left;
  
  box-shadow: -2px 5px 10px -5px rgba(0,0,0, 0.25);


  .card-flat .card-panel,
  .card-folded .card-panel-cover {

    &:after {
      content: "";
      position: absolute;
      background: palegoldenrod;
      border-radius: 10%  10% 40% 40%;
      border: 1px solid rgba(0,0,0, 0.2);
      top: 0;
      width: 5px; height: 10px;
      z-index: 100;
      transform: translate3d(-50%, -75%, 1px) rotateZ(-45deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// card-line.vue?05c2bcee